export default __webpack_public_path__ + "static/media/Gargoyle Master's Demise.8ad044a2.jpg";